import { callAct, isOk } from './apiConfig';

/*
 * boost — קידום העסק (BOOST): a business pays to rank FIRST in the public /discover directory.
 * v1 is priced by DAYS and activated MANUALLY by the owner (no payment gateway yet). Backed by
 * the setBusinessBoost / getBusinessBoost acts, both AUTHENTICATED and scoped server-side to the
 * session business (a business can only ever boost/cancel ITSELF).
 *
 * Status shape: { boostedUntil: string|null, active: boolean }.
 *   boostedUntil — the datetime the boost runs until (or null when not boosted).
 *   active       — true when boostedUntil is in the future (business currently ranks first).
 */

// Read the current boost status. Returns { boostedUntil: null, active: false } on error.
export async function getBoost() {
    try {
        const envelope = await callAct('getBusinessBoost', {});
        if (isOk(envelope) && envelope.data) {
            return {
                boostedUntil: envelope.data.boostedUntil ?? null,
                active: !!envelope.data.active,
            };
        }
    } catch (e) { /* act not available */ }
    return { boostedUntil: null, active: false };
}

// Start (days>0) or cancel (days<=0) the boost. Days are clamped server-side to [0,365].
// Returns the freshly-persisted status { boostedUntil, active }, or the safe default on error.
export async function setBoost(days) {
    try {
        const envelope = await callAct('setBusinessBoost', { boostDays: Number(days) || 0 });
        if (isOk(envelope) && envelope.data) {
            return {
                boostedUntil: envelope.data.boostedUntil ?? null,
                active: !!envelope.data.active,
            };
        }
    } catch (e) { /* act not available */ }
    return { boostedUntil: null, active: false };
}

export default { getBoost, setBoost };
